import { FC } from 'react';
import { Result } from 'antd';

const PageNotFound: FC = () => <Result status="404" title="404" subTitle="Sorry, page not found." />;

export default PageNotFound;
